import { render } from "./PaymentConfirm.vue?vue&type=template&id=12ab4366&ts=true"
import script from "./PaymentConfirm.vue?vue&type=script&lang=ts"
export * from "./PaymentConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build_f60bedd5/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__